const BLUR_CLASS = 'app-content-protected-blur';

const injectBlurStyles = () => {
  if (document.getElementById('security-blur-style')) return;
  const style = document.createElement('style');
  style.id = 'security-blur-style';
  style.textContent = `.${BLUR_CLASS} { filter: blur(18px); transition: filter 0.15s ease; }`;
  document.head.appendChild(style);
};

const flashBlur = () => {
  injectBlurStyles();
  document.body.classList.add(BLUR_CLASS);
  window.setTimeout(() => document.body.classList.remove(BLUR_CLASS), 600);
};

// Client-side deterrents against casual DevTools access and screenshot/recording.
// Note: PrintScreen, Win+Shift+S, Game Bar (Win+G / Win+Alt+R) etc. are captured by
// the OS before the page sees them, so they can't truly be blocked from a web page -
// only reacted to after the fact (PrintScreen) or not at all (the Win+ combos).
export const initSecurity = () => {
  document.addEventListener('contextmenu', (e) => e.preventDefault());

  document.addEventListener('keydown', (e) => {
    const key = e.key.toLowerCase();

    // DevTools shortcuts
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) ||
      (e.ctrlKey && key === 'u')
    ) {
      e.preventDefault();
      return;
    }

    // Save / print page
    if (e.ctrlKey && (key === 's' || key === 'p')) {
      e.preventDefault();
      return;
    }

    // Snipping tool (Win+Shift+S) - blocked by the OS in most browsers, handled here
    // in case it reaches the page anyway.
    if (e.metaKey && e.shiftKey && key === 's') {
      e.preventDefault();
      flashBlur();
    }
  });

  // PrintScreen can't be preventDefault()-ed - the OS already captured the frame by
  // the time this fires. Scrub the clipboard and flash a blur as a visible deterrent.
  document.addEventListener('keyup', (e) => {
    if (e.key === 'PrintScreen') {
      flashBlur();
      navigator.clipboard?.writeText('').catch(() => {});
    }
  });
};

export default initSecurity;
